// extracted by mini-css-extract-plugin
export default {"RsBasicRaioGroup":"basicRadio_RsBasicRaioGroup__OoMBr"};